var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom_fix"},[_c('a',{staticClass:"my_btn",attrs:{"target":"_blank","href":_vm.$store.state.storeObj ? _vm.$store.state.storeObj.acf.airreserve : '/'}},[_vm._v("予約する"),_c('i',{staticClass:"fas fa-chevron-right"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }